import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const CustomButton = React.forwardRef(({
  children,
  variant = 'contained',
  color = 'primary',
  size = 'medium',
  startIcon,
  endIcon,
  sx = {},
  ...props
}, ref) => {
  const theme = useTheme();
  return (
    <Button
      ref={ref}
      variant={variant}
      color={color}
      size={size}
      startIcon={startIcon}
      endIcon={endIcon}
      sx={{
        borderRadius: theme.shape.borderRadius * 2,
        fontWeight: 600,
        textTransform: 'none',
        boxShadow: 'none',
        px: 3,
        py: 1.25,
        fontSize: '1rem',
        transition: 'background 0.2s, color 0.2s',
        '&:hover': {
          boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
          backgroundColor: color === 'primary'
            ? theme.palette.primary.dark
            : color === 'secondary'
              ? theme.palette.secondary.dark
              : undefined,
        },
        ...sx,
      }}
      {...props}
    >
      {children}
    </Button>
  );
});

CustomButton.propTypes = {
  children: PropTypes.node,
  variant: PropTypes.oneOf(['contained', 'outlined', 'text']),
  color: PropTypes.oneOf(['primary', 'secondary', 'error', 'info', 'success', 'warning', 'inherit']),
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  startIcon: PropTypes.node,
  endIcon: PropTypes.node,
  sx: PropTypes.object,
};

export default CustomButton; 